const envValue = (key) =>
    process.env[`REACT_APP_${key}`] ||
    process.env[`REACT_APP_${key.toUpperCase()}`] ||
    process.env[key] ||
    process.env[key.toUpperCase()] ||
    ''

const normalizeUrl = (value) => value ? value.replace(/\/+$/, '') : ''

const isProductionHost = () =>
    typeof window !== 'undefined' &&
    !['localhost', '127.0.0.1'].includes(window.location.hostname)

export const getCustomerPanelUrl = () => {
    const fallback = isProductionHost() ? 'https://itemzo.net' : 'http://localhost:3000'
    return normalizeUrl(
        isProductionHost()
            ? envValue('user_panel_production_url')
            : envValue('user_panel_local_url') || envValue('user_panel_lcoal_url')
    ) || fallback
}

export const getDashboardPanelUrl = () => {
    const fallback = isProductionHost() ? 'https://dashboard.itemzo.net' : 'http://localhost:3001'
    return normalizeUrl(
        isProductionHost()
            ? envValue('admin_panel_production_url')
            : envValue('admin_panel_local_url') || envValue('admin_panel_lcoal_url')
    ) || fallback
}

export const getDashboardHomePath = (role) => {
    if (role === 'admin') return '/admin/dashboard'
    // ✅ Phase 3.1 — staff məhdud daxili paneldə qarşılanır
    if (role === 'staff') return '/admin/dashboard/staff-home'
    return '/seller/dashboard'
}
